import { render, staticRenderFns } from "./LeccionB4.vue?vue&type=template&id=1034de20&"
import script from "./LeccionB4.vue?vue&type=script&lang=js&"
export * from "./LeccionB4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports